import pink from '@material-ui/core/colors/pink'

export const lightTheme = {
	palette: {
		primary: {
			main: pink[700],
		},
		background: {
			paper: '#f1eeff',
		},
	},
}
